import { call, put } from 'redux-saga/effects';
import { BACKEND_URL } from '../../../configs';
import { loadListParkingMeterFailed, loadListParkingMeterSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import processError from '../../../utils/processError';
import makeRequest from '../../../utils/makeRequest';
import { OK } from '../../../configs/serverStatusCodes';

export default function* loadListParkingMeter(action) {
  try {
    const url = `${BACKEND_URL}/host-problems/short-list`;
    const pool = {
      filter: {
        type: 1,
      },
    };
    const userDataResponse = yield makeRequest(url, pool, action, 'POST');
    const responseJson = yield userDataResponse.json();
    if (userDataResponse && userDataResponse.status === OK) {
      yield put(loadListParkingMeterSuccessful(responseJson));
      yield call(resolveActionPromise(action, responseJson));
    } else {
      yield put(loadListParkingMeterFailed(responseJson));
      yield call(rejectActionPromise(action, responseJson));
    }
  } catch (e) {
    yield put(loadListParkingMeterFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
